module.exports = __webpack_public_path__ + "static/img/icon_logo.36248af5.png";